import React from "react";
import { Link } from "gatsby";
import useTranslation from "locales";

import Cookies from "../../assets/icons/cookies.svg";

import "./cookie-banner.scss";

const CookieBanner = ({ onClick, lang }) => {
  const { t } = useTranslation(lang);
  return (
    <div className="cookie-banner">
      <div className="container cookie-banner__container">
        <img src={Cookies} alt="" className="cookie-banner__img" />
        <p className="cookie-banner__text">
          Korzystamy z plików cookies w celu optymalizacji usług. Jeśli
          korzystasz z naszej witryny bez zmiany ustawień dotyczących cookies
          oznacza, że wyrażasz zgodę na zamieszczanie ich przez nas w Twoim
          urządzeniu.{" "}
          <Link
            to={t("/polityka-prywatnosci/")}
            className="cookie-banner__link"
          >
            {t("Czytaj więcej")}
          </Link>
          .
        </p>
        <button
          className="btn btn--outline cookie-banner__btn"
          type="button"
          onClick={onClick}
        >
          {t("Akceptuję")}
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;
